import React from "react";
import DragItem from "./Items/Item";

import "./Items.css";

import icon1 from "../../assets/icons/1.svg";
import icon2 from "../../assets/icons/2.svg";
import icon3 from "../../assets/icons/3.svg";
import icon4 from "../../assets/icons/4.svg";
import icon5 from "../../assets/icons/5.svg";
import icon6 from "../../assets/icons/6.svg";
import icon7 from "../../assets/icons/7.svg";
import icon8 from "../../assets/icons/8.svg";
import icon9 from "../../assets/icons/9.svg";
import icon10 from "../../assets/icons/10.svg";
import icon11 from "../../assets/icons/11.svg";
import icon12 from "../../assets/icons/12.svg";
import icon13 from "../../assets/icons/13.svg";
import icon14 from "../../assets/icons/14.svg";
import icon15 from "../../assets/icons/15.svg";
import icon16 from "../../assets/icons/16.svg";
import icon17 from "../../assets/icons/17.svg";
import icon18 from "../../assets/icons/18.svg";
import icon19 from "../../assets/icons/19.svg";
import icon20 from "../../assets/icons/20.svg";
import icon21 from "../../assets/icons/21.svg";
import icon22 from "../../assets/icons/22.svg";
import icon23 from "../../assets/icons/23.svg";
import icon24 from "../../assets/icons/24.svg";
import icon25 from "../../assets/icons/25.svg";
import icon26 from "../../assets/icons/26.svg";
import icon27 from "../../assets/icons/27.svg";
import icon28 from "../../assets/icons/28.svg";
import icon29 from "../../assets/icons/29.svg";
import icon30 from "../../assets/icons/30.svg";

const animalParts = [
  {
    id: "Licka",
    name: "Líčka",
    icon: icon1,
  },
  {
    id: "Jazyk",
    name: "Jazyk",
    icon: icon2,
  },
  {
    id: "Krk",
    name: "Krk",
    icon: icon3,
  },
  {
    id: "Hrudi",
    name: "Hrudí",
    icon: icon4,
  },
  {
    id: "Podpleci",
    name: "Podplečí",
    icon: icon5,
  },
  {
    id: "VRostenec",
    name: "Vysoký roštěnec",
    icon: icon6,
  },
  {
    id: "KPlec",
    name: "Kulatá plec - falešná svíčková",
    icon: icon7,
  },
  {
    id: "LPlec",
    name: "Loupaná plec",
    icon: icon8,
  },
  {
    id: "VPlec",
    name: "Velká plec",
    icon: icon9,
  },
  {
    id: "Husicka",
    name: "Husička",
    icon: icon10,
  },
  {
    id: "KPredni",
    name: "Kližka-přední",
    icon: icon11,
  },
  {
    id: "VZebro",
    name: "Žebro Vysoké",
    icon: icon12,
  },
  {
    id: "ZHole",
    name: "Žebro holé",
    icon: icon13,
  },
  {
    id: "Oponka",
    name: "Oponka",
    icon: icon14,
  },
  {
    id: "Veverka",
    name: "Veverka",
    icon: icon15,
  },
  {
    id: "NRostenec",
    name: "Nízký roštěnec",
    icon: icon16,
  },
  {
    id: "Svickova",
    name: "Svíčková",
    icon: icon17,
  },
  {
    id: "ZNizke",
    name: "Žebro nízké",
    icon: icon18,
  },
  {
    id: "PupekFlank",
    name: "Pupek - Flank steak",
    icon: icon19,
  },
  {
    id: "PupekFlap",
    name: "Pupek - Flap steak",
    icon: icon20,
  },
  {
    id: "Holubicka",
    name: "Holubička",
    icon: icon21,
  },
  {
    id: "Orech",
    name: "Orech",
    icon: icon22,
  },
  {
    id: "KvetovaSpicka",
    name: "Květová špička",
    icon: icon23,
  },
  {
    id: "TabulovaSpicka",
    name: "Tabulová špička",
    icon: icon24,
  },
  {
    id: "VrchniSal",
    name: "Vrchní šál",
    icon: icon25,
  },
  {
    id: "SpodniSal",
    name: "Spodní šál",
    icon: icon26,
  },
  {
    id: "Valecek",
    name: "Váleček",
    icon: icon27,
  },
  {
    id: "Karabacek",
    name: "Karabáček",
    icon: icon28,
  },
  {
    id: "Klizka",
    name: "Kližka - zadní",
    icon: icon29,
  },
  {
    id: "Ohanka",
    name: "Oháňka",
    icon: icon30,
  },
];

const Items = (props) => (
  <div className="KurzColumnContainer">
    {animalParts.map((part) => {
      return (
        <DragItem
          key={part.id}
          id={part.id}
          name={part.name}
          icon={part.icon}
        />
      );
    })}
  </div>
);

export default Items;
